import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Login } from "../login/Login";

// Landing spot for the PingID OAuth redirect (backend/auth/pingid_routes.py
// redirects here after the token exchange). On success there's nothing to show;
// on failure, `error` carries a short reason code for troubleshooting.
const AuthCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const error = searchParams.get("error");

    useEffect(() => {
        if (!error) {
            navigate("/", { replace: true });
        }
    }, [error, navigate]);

    if (error) {
        return <Login initialError={error} />;
    }

    return null;
};

export default AuthCallback;
